import { or, rankWith, scopeEndsWith } from "@jsonforms/core";
import { withJsonFormsControlProps } from "@jsonforms/react";
import { fileTypeFromBlob } from "file-type";
import { File, FileType } from "multitool-sdk-core";
import FileUploader from "./FileUploader";

interface FileUploadControlProps {
  data: any;
  handleChange(path: string, value: any): void;
  path: string;
}

const FileUploadControl = ({ handleChange, path }: FileUploadControlProps) => (
  <FileUploader
    onSubmit={async (body) => {
      const type = await fileTypeFromBlob(body);
      const f = new File({
        name: body.name.replace(/\.[^/.]+$/, ""),
        fileType: FileType.BINARY,
        type: type?.mime,
        extension: type?.ext,
      });

      await f.write({
        body: new Blob([await body.arrayBuffer()], { type: body.type }),
        contentType: body.type,
      });
      handleChange(path, f);
    }}
  />
);

export default withJsonFormsControlProps(FileUploadControl);

export const fileUploadTester = rankWith(
  3, //increase rank as needed
  or(scopeEndsWith("Image"), scopeEndsWith("File"))
);
